import { keycloak } from './keycloak'
import { users } from './users'
import { payments } from './payments'
import { scans } from './scans'
import { luna } from './luna'
import { identifications } from './identifications'
import { ekeng } from './ekeng'
import { documents } from './documents'
import { referral } from './referral'
import { banner } from './banner'
import { settings } from './settings'
import { journal } from './journal'
import { providers } from './providers'
import { blackList } from './blackLlst'
import { faq } from './faq'
import { auth } from './auth'

export const api = {
  auth,
  users,
  payments,
  keycloak,
  scans,
  luna,
  identifications,
  ekeng,
  documents,
  referral,
  banner,
  settings,
  journal,
  providers,
  blackList,
  faq,
}
